
    import {Component, Vue} from 'vue-property-decorator';
    import ElDivider from 'element-ui/packages/divider/src/main.vue';
    import {listProductUpdateLog, ListProductUpdateLogForm, ProductUpdateLog} from '@/service/update-log';
    import {Button, Col, Loading, Row} from 'element-ui';

    Vue.use(Button);
    Vue.use(Col);
    Vue.use(Row);
    Vue.use(Loading.directive);
    @Component({
        components: {
            ElDivider,
        },
    })
    export default class ProductUpdateLogs extends Vue {
        private loading: boolean = false;
        private logList: ProductUpdateLog[] = [];
        private listForm: ListProductUpdateLogForm = {
            pz: 10,
        };
        private hasMoreLog: boolean = true;

        private created() {
            document.title = '快课产品更新日志';
            this.listLog(false);
        }

        private listLog(loadMore: boolean) {
            this.loading = true;
            if (!loadMore) {
                this.logList = [];
                delete this.listForm.marker;
            }
            listProductUpdateLog(this.listForm)
                .then((res: ProductUpdateLog[]) => {
                    if (res.length === 0) {
                        this.hasMoreLog = false;
                        delete this.listForm.marker;
                        return;
                    }
                    this.logList.push(...res);
                    this.listForm.marker = res[res.length - 1].yearMonthDay;
                    if (res.length < this.listForm.pz) {
                        this.hasMoreLog = false;
                        delete this.listForm.marker;
                    }
                })
                .catch((error) => this.$message.warning(error))
                .finally(() => this.loading = false);
        }

        private loadMoreLog() {
            this.listLog(true);
        }

        private buildDate(yearMonthDay: number): string {
            const year = parseInt((yearMonthDay / 10000).toFixed(), 10);
            const monthDay = yearMonthDay - year * 10000;
            const month = parseInt(((monthDay) / 100).toFixed(), 10);
            const day = monthDay - month * 100;
            return `${year}年${month}月${day}日`;
        }


    }
